import { z } from 'zod';
/**
 * User interaction events defined in Logto RFC 0004.
 * @see {@link https://github.com/logto-io/rfcs | Logto RFCs} for more information.
 */
export var InteractionEvent;
(function (InteractionEvent) {
    InteractionEvent["SignIn"] = "SignIn";
    InteractionEvent["Register"] = "Register";
    InteractionEvent["ForgotPassword"] = "ForgotPassword";
    /**
     * Step-up authentication: elevate an existing session to a higher ACR level
     * (e.g. password-only → MFA-verified) without requiring full re-login.
     *
     * Reuses the already-identified user from the OIDC session and asks only for
     * the additional factor(s) needed to satisfy the requested `acr_values`.
     */
    InteractionEvent["StepUp"] = "StepUp";
})(InteractionEvent || (InteractionEvent = {}));
export const eventGuard = z.nativeEnum(InteractionEvent);
